/** Kod typu reklamy jako ciemna „pastylka” (XL, L, HALF…). */
export function TypeCode({ id }: { id: string }) {
  return (
    <code className="rounded bg-slate-900 px-1.5 py-0.5 font-mono text-xs font-semibold text-white">
      {id}
    </code>
  )
}

/** Trzy wartości desktop · tablet · mobile w jednej komórce tabeli. */
export function Triple({ values, unit }: { values: [number, number, number]; unit?: string }) {
  return (
    <span className="inline-flex items-baseline gap-1.5 font-mono text-xs tabular-nums text-slate-700">
      {values.map((v, i) => (
        <span key={i} className="inline-flex items-baseline gap-1.5">
          {i > 0 && <span className="text-slate-300">·</span>}
          <span>{v}</span>
        </span>
      ))}
      {unit && <span className="text-slate-400">{unit}</span>}
    </span>
  )
}
